import React from "react";

const SolutionHero: React.FC = () => {
  return (
    <div className="relative min-h-screen w-full">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          width: '100%',
          height: '100%',
          backgroundImage: 'url("/solutions/solutionglobe1.avif")',
        }}
      />

      {/* <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-transparent to-black/40">
        <div className="absolute inset-0 bg-gradient-to-tr from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-tl from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-br from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-bl from-black/40 via-transparent to-black/30" />
        <div className="absolute inset-0 bg-radial-gradient(circle at center, transparent 0%, rgba(0,0,0,0.4) 100%)" />
      </div> */}

      <div className="relative z-10 flex min-h-screen flex-col items-center justify-start px-6 text-center md:px-20 pt-28">
        <h1 className="text-4xl font-bold text-white md:text-4xl lg:text-6xl xl:text-6xl px-4 lg:px-44">
          Spectrum
        </h1>
      </div>
    </div>
  );
};

export default SolutionHero;